// Return array of parent nodes from a graphql query
export const parentList = (list: unknown[]): unknown[] => {
  const parentNodes: unknown[] = []

  list.map((item: any) => {
    if (item.parentId == null) {
      parentNodes.push(item)
    }
  })

  return parentNodes
}
